import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import styled from "styled-components"
import {Body, H3} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import History, {historyContext} from "@irati/utils/history"
import React from "react"
import mainTheme from "@irati/ui/src/global/theme"
import recognitionTracking from "@irati-tracking/recognition/recognition"
import authentication from "@irati/auth"
import {RecognitionRoutes} from "../../../enums/Routes"

interface Props {
  closeModal: () => void
}
const StyledHeader = styled(Flex)`
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: ${mainTheme.spacing.three};
  border-radius: ${mainTheme.spacing.one};
`
const StyledHeaderBox = styled(Flex)`
  position: relative;
  justify-content: center;
  align-items: flex-start;
  background: ${mainTheme.colors.primary2};
  width: 120px;
  height: 160px;
  border-radius: ${mainTheme.spacing.one};
  ${({theme}) => theme.mediaQueries.minWidthMedia.phoneLandscape`
    width: 200px;
    height: 240px;
  `}
`
const StyledImg = styled.img`
  width: 100%;
  margin-top: ${mainTheme.spacing.one};
  object-fit: contain;
`
const StyledMockImg = styled.img`
  width: 200%;
  position: absolute;
  bottom: ${mainTheme.spacing.one};
  object-fit: contain;
`
const giftAnimation = "https://res.cloudinary.com/perkbox/image/upload/v1700218238/c6b2199e-0b21-48e8-adaf-1217f80384c0.gif"
const recognitionsMock = "https://res.cloudinary.com/perkbox/image/upload/v1710243658/29483135-f2a1-4ed5-b826-c685a69cbcc2.png"

const OnboardingContent = (props: Props, context) => {
  const {closeModal} = props
  const user = `${authentication.user().firstName} ${authentication.user().lastName}`
  const createFirstRecognition = () => {
    closeModal()
    recognitionTracking.completeOnboarding()
    History.push({pathname: RecognitionRoutes.CREATE_RECOGNITION, state: {isFirstRecognition: true}}, context)
  }
  return (
    <Flex direction="column" alignItems="center" marginTop={2}>
      <StyledHeader>
        <StyledHeaderBox>
          <StyledImg src={giftAnimation} />
          <StyledMockImg src={recognitionsMock} />
        </StyledHeaderBox>
      </StyledHeader>
      <H3 marginTop={3} marginBottom={1} textAlign="center">
        <FormattedMessage id="recognition.onboarding.heading.welcome" values={{user}} />
      </H3>
      <Body small textAlign="center">
        <FormattedMessage id="recognition.onboarding.body.welcome" />
      </Body>
      <Button marginTop={6} primary full onClick={createFirstRecognition}>
        <FormattedMessage id="recognition.onboarding.btn.joinCelebration" />
      </Button>
    </Flex>
  )
}

OnboardingContent.contextTypes = historyContext
export default OnboardingContent
